export type ListTracEvent = 'lead' | 'share' | 'view' | 'favorite' | 'gallery' | 'vTour';

export const generateListTracEvent = async (event: {
  type: ListTracEvent;
  listingId: string;
  zipCode: string;
}) => {
  const { listingId, type, zipCode } = event;
  if (!process.env.NEXT_PUBLIC_LISTTRAC_ID) {
    return;
  } else {
    await fetch(
      `//code.listtrac.com/sm/dt/${process.env.NEXT_PUBLIC_LISTTRAC_ID}/${type}/?lid=${listingId}&zc=${zipCode}`,
    );
  }
};
